import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Dialog from "./Dialog";
import { FeedPostState } from "../hooks/useFeedPost";

/** View or remove a debate that is on the public feed. */
export function FeedPostDialog({
  state,
  debateId,
  open,
  onClose,
}: {
  state: FeedPostState;
  debateId: string;
  open: boolean;
  onClose: () => void;
}) {
  return (
    <Dialog open={open} onClose={onClose} title="On the public feed">
      <p className="text-sm text-muted leading-6">
        Anyone can read this debate and comment on it. Removing it takes it off the feed and deletes its comments.
      </p>
      <Link
        to={`/feed/${debateId}`}
        onClick={onClose}
        className="button-secondary w-full focus:outline-none focus-visible:ring-2 focus-visible:ring-focus"
      >
        View post
        <ArrowUpRight size={16} aria-hidden="true" />
      </Link>
      <button
        type="button"
        onClick={() => {
          void state.unpublish();
          onClose();
        }}
        className="button-secondary w-full"
      >
        Remove from feed
      </button>
    </Dialog>
  );
}
